import IAccount from 'types/IAccount';

export interface IWorkflowUserName {
  name: string;
  isAccountWorker: boolean;
}

interface IUserLike {
  full_name?: string;
  username?: string;
}

export default function formatWorkflowUser(
  userId: string,
  user: IUserLike | undefined,
  account: IAccount | undefined,
): IWorkflowUserName {
  if (user) {
    const fullName = user.full_name?.trim();
    return { name: fullName || user.username || userId, isAccountWorker: false };
  }

  if (account) {
    return { name: account.organization_name || userId, isAccountWorker: true };
  }

  return { name: userId, isAccountWorker: false };
}
